import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "MartiniGlass",
  "use": "MartiniGlass-usage",
  "viewBox": "0 0 55 54",
  "content": "<symbol viewBox=\"0 0 55 54\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MartiniGlass\">\n  <path d=\"M54.3999 6V0H0.399902V6L24.3999 33V48H9.3999V54H45.3999V48H30.3999V33L54.3999 6ZM13.6899 12L8.3799 6H46.4499L41.1099 12H13.6899Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol